import classNames from 'classnames';

import MellowMark from '../../../../toolkit/core-kit/assets/mellow-mark.svg?react';

import styles from './index.module.scss';

type Props = {
  readonly className?: string;
};

function Ring({ className }: Props) {
  return (
    <MellowMark
      aria-hidden
      width="16"
      height="16"
      className={classNames(styles.pulse, className)}
    />
  );
}

function Daisy({ className }: Props) {
  return (
    <MellowMark
      aria-hidden
      width="32"
      height="32"
      className={classNames(styles.pulse, className)}
    />
  );
}

export { Ring, Daisy };
